import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import { Socket } from 'ngx-socket-io';
import { Message } from '../classes/message';

@Injectable({
  providedIn: 'root'
})

export class MessageService {
  private filtersSubject = new ReplaySubject<any>();

  constructor(private httpClient: HttpClient, private socket: Socket) { }

  public contactsPaused(): Observable<any> {
    return this.httpClient.get(`/api/customers/contacts`, { params: new HttpParams().set('pause_chat_ai', 'true') });
  }

  public salesChats(): Observable<any> {
    return this.httpClient.get(`/api/sales-chats`);
  }
  
  public employeePaused(): Observable<any> {
    return this.httpClient.get(`/api/employees`, { params: new HttpParams().set('pause_chat_ai', 'true') });
  }

  filters() {
    return this.filtersSubject.asObservable();
  }

  filterAdd(subject: string) {
    this.filtersSubject.next({ action: 'add', subject: subject })
  }

  filterRemove(subject: string) {
    this.filtersSubject.next({ action: 'remove', subject: subject })
  }

  public customerList(customerId: number): Observable<any> {
    return this.httpClient.get(`/api/customers/${customerId}/messages`);
  }

  public contactList(customerId: number, contactId: number): Observable<any> {
    return this.httpClient.get(`/api/customers/${customerId}/contacts/${contactId}/messages`);
  }

  public contactsSend(contacts: number[], message: string, shiftId?: number): Observable<any> {
    return this.httpClient.post(`/api/customers/contacts/messages`, { contacts: contacts, message: message, shift: shiftId });
  }

  public contactSend(customerId: number, contactId: number, message: string): Observable<any> {
    return this.httpClient.post(`/api/customers/${customerId}/contacts/${contactId}/messages`, { message: message });
  }

  public latest(): Observable<any> {
    return this.httpClient.get(`/api/messages/latest`);
  }

  public deliveredApplicant(applicantId: number): Observable<Message> {
    return this.socket.fromEvent(`delivered_applicant:${applicantId}`)
  }

  public deliveredContact(contactId: number): Observable<Message> {
    return this.socket.fromEvent(`delivered_contact:${contactId}`)
  }

  public deliveredEmployee(employeeId: number): Observable<Message> {
    return this.socket.fromEvent(`delivered_employee:${employeeId}`)
  }

  public listen(): Observable<Message> {
    return this.socket.fromEvent('message')
  }

  public join(room: string): Observable<Message> {
    this.socket.emit('join', { room: room })
    return this.socket.fromEvent('message')
  }

  public leave(room: string) {
    this.socket.emit('leave', { room: room })
    return this.socket.removeListener('message')
  }

  public listenPausedChats(): Observable<any> {
    return this.socket.fromEvent('chat_paused')
  }

  public unlistenPausedChats(): Observable<any> {
    return this.socket.removeListener('chat_paused')
  }

  public listenContinuedChats(): Observable<any> {
    return this.socket.fromEvent('chat_continued')
  }

  public unlistenContinuedChats(): Observable<any> {
    return this.socket.removeListener('chat_continued')
  }

  public unlisten() {
    return this.socket.removeListener('message')
  }

  public applicantList(applicantId: number): Observable<any> {
    return this.httpClient.get(`/api/applicants/${applicantId}/messages`);
  }

  public applicantSend(applicantId: number, message: string): Observable<any> {
    return this.httpClient.post(`/api/applicants/${applicantId}/messages`, { message: message });
  }

  public employeeList(employeeId: number): Observable<any> {
    return this.httpClient.get(`/api/employees/${employeeId}/messages`);
  }

  public employeeSend(employeeId: number, message: string): Observable<any> {
    return this.httpClient.post(`/api/employees/${employeeId}/messages`, { message: message });
  }

  public employeeSendShift(employeeId: number, shiftId: number, message: string): Observable<any> {
    return this.httpClient.post(`/api/employees/${employeeId}/messages`, { message: message, shift_id: shiftId });
  }

  public employeesSend(employees: number[], message: string, shiftId?: number): Observable<any> {
    return this.httpClient.post(`/api/employees/messages`, { employees: employees, message: message, shift_id: shiftId  });
  }

  public shiftConfirmCustomerMessageTemplateRender(shiftId: number): Observable<any> {
    return this.httpClient.get(`/api/shifts/${shiftId}/customer-confirmation`);
  }

  public shiftConfirmEmployeeMessageTemplateRender(shiftId: number): Observable<any> {
    return this.httpClient.get(`/api/shifts/${shiftId}/employee-confirmation`);
  }

  public customerMessageTemplates(): Observable<any> {
    return this.httpClient.get(`/api/message-templates/customer`);
  }

  public customerShiftMessageTemplates(): Observable<any> {
    return this.httpClient.get(`/api/message-templates/customer-shift-message`);
  }

  public customerShiftConfirmationMessageTemplates(): Observable<any> {
    return this.httpClient.get(`/api/message-templates/customer-shift-confirmation`);
  }

  public employeeMessageTemplates(): Observable<any> {
    return this.httpClient.get(`/api/message-templates/employee`);
  }

  public employeeShiftMessageTemplates(): Observable<any> {
    return this.httpClient.get(`/api/message-templates/employee-shift-message`);
  }

  public employeeShiftConfirmationMessageTemplates(): Observable<any> {
    return this.httpClient.get(`/api/message-templates/employee-shift-confirmation`);
  }

  public messageTemplateRender(templateId: number, data: {}): Observable<any> {
    return this.httpClient.post(`/api/message-templates/${templateId}/render`, data);
  }
  
  public shiftList(shiftId: number): Observable<any> {
    return this.httpClient.get(`/api/shifts/${shiftId}/messages`);
  }
  public connect() {
    this.socket.connect();
  }
  
  public disconnect() {
    this.socket.disconnect(true);
  }
}
